/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import Layout from 'components/Layout';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import {
	Button,
	ButtonContainer,
	FileModal,
} from '@fitinsur/components'
import { Content } from './styles';
import { useGetDocuments } from 'services/DocumentsService';
import { LoaderContext } from '@fitinsur/contexts'
import { useGetOperationAsync } from 'services/OperationService';


export default function EndorsementAdjustmentsCorrectionsPolicy({ permissions, ...props }) {
	const { updateIsLoadingStatus } = useContext(LoaderContext);
	const history = useHistory();
	const formikRef = useRef({});
	const [operation, setOperation] = useState({});
	const [documents, setDocuments] = useState([]);
	

	const {
		data: useGetDocumentsData,
		loading: useGetDocumentsLoading,
		error: useGetDocumentsError,
		status: useGetDocumentsStatus,
		request: useGetDocumentsRequest
	} = useGetDocuments(props.match.params.idOperation);


	const {
		loading: useGetOperationLoading,
		request: useGetOperationRequest
	} = useGetOperationAsync(props.match.params.idOperation);

	  
	useEffect(() => {
		updateIsLoadingStatus(
			useGetDocumentsLoading || 
			useGetOperationLoading
		)
	}, [useGetDocumentsLoading, useGetOperationLoading]);

	useEffect(() => {
		if (props.match.params.idOperation) {
			useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
				let operationData;
				if (response.status === 200) {
					operationData = response.data?.value;
					setOperation(operationData);
					useGetDocumentsRequest(null, { idDomain: 450 });
				}
			});
		}
	}, []);

	useEffect(() => {
		if (!useGetDocumentsStatus) return;

		if (useGetDocumentsStatus === 200) {
			if (useGetDocumentsData.value.length) {
				setDocuments(useGetDocumentsData.value.map(doc => ({
					idDocument: doc.idDocument,
					idDomainDescription: doc.idDomainDescription,
					idReport: doc.idReport,
					idOperation: doc.idOperation,
					reportToken: doc.reportToken,
					url: doc.url,
					fileName: doc.documentMetadata.fileName
				})))
			}
		}
	}, [useGetDocumentsStatus]);


	return (
		<Layout
			title={""}
			subtitle={`${operation?.productName || ""}`}
			idOperation={operation?.idOperation}
		>
			<StepNavigation
				stage={3}
				idOperation={props?.match?.params?.idOperation}
				permissions={permissions}
			/>

			<BrokingSummary
				idProduct={props?.match?.params?.idProduct}
				idOperation={props?.match?.params?.idOperation}
				history={history}
				permissions={permissions}
			/>

			<Content>
				<Formik
					validateOnChange={false}
					innerRef={formikRef}
					initialValues={{ }}
					enableReinitialize={true}
					onSubmit={{}}
				>
					{({ values, errors, setFieldValue, setFieldError }) => {
						return (
							<Form onKeyDown={(e) => {
								if (e.key === 'Enter') e.preventDefault();
							}}>	
								<FileModal documents={documents} />

								<ButtonContainer style={{ padding: '0 10px' }}>
									<Button forth style={{ width: 'auto' }} onClick={() => history.push(`/polices`)}> &lt; VOLTAR PARA A LISTA </Button>
								</ButtonContainer>
							</Form>
						)
					}}
				</Formik>
			</Content>
		</Layout>
	)
}
